/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchAuditFloatingInventory = ({
  order,
  line,
  chassis,
  dealer,
  dateFrom,
  dateTo,
}) =>
  apiActionCreator({
    'endpoint':
      `/vehAudi/audit-floating-inventory?order=${order || ''}&line=${line || ''}&chassis=${chassis || ''}&dealer=${dealer || ''}&date_from=${dateFrom || ''}&date_to=${dateTo || ''}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT,
      ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT,
      [
        ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchAuditFloatingClients = ({
  document,
  lastNames,
  names,
  dateFrom,
  dateTo,
}) =>
  apiActionCreator({
    'endpoint':
      `/vehAudi/audit-floating-client?document=${document || ''}&last_name=${lastNames || ''}&name=${names || ''}&date_from=${dateFrom || ''}&date_to=${dateTo || ''}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT,
      ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT,
      [
        ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const setCurrentAuditScreen = (screen) => ({
  'type': ActionTypes.CHANGE_CURRENT_SCREEN_FLOAT_AUDIT,
  'payload': screen,
});

export const cleanFloatingAuditScreen = () => ({
  'type': ActionTypes.CLEAN_FLOATING_AUDIT_SCREEN,
  'payload': null,
});

export const fetchFloatingClientsAuditDocument = (prop, value) =>
  apiActionCreator({
    'endpoint': `/vehAudi/float-clients-audi-list/${prop}?value=${value}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT,
      ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT,
      [
        ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchFloatingClientsAuditName = (prop, value) =>
  apiActionCreator({
    'endpoint': `/vehAudi/float-clients-audi-list/${prop}?value=${value}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT_LIST_NAMES,
      ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES,
      [
        ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchFloatingClientsAuditLastName = (prop, value) =>
  apiActionCreator({
    'endpoint': `/vehAudi/float-clients-audi-list/${prop}?value=${value}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES,
      ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES,
      [
        ActionTypes.FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
  
export const fetchFloatingInventoryAuditOrder = (prop, value) =>
  apiActionCreator({
    'endpoint': `/vehAudi/float-inventory-audi-list/${prop}?value=${value}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT_LIST_ORDER,
      ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER,
      [
        ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchFloatingInventoryAuditChassis = (prop, value) =>
  apiActionCreator({
    'endpoint': `/vehAudi/float-inventory-audi-list/${prop}?value=${value}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS,
      ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS,
      [
        ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_CHASSIS,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchAuditFloatingInventoryExcel = ({
  order,
  line,
  chassis,
  dealer,
  dateFrom,
  dateTo,
}) =>
  apiActionCreator({
    'endpoint':
      `/vehAudi/audit-floating-inventory-excel?order=${order || ''}&line=${line || ''}&chassis=${chassis || ''}&dealer=${dealer || ''}&date_from=${dateFrom || ''}&date_to=${dateTo || ''}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT_EXCEL,
      ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL,
      [
        ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
export const clearFloatInventoryAudit = () => {
  return {
    'type': ActionTypes.CLEAR_FLOAT_INVENTORY_AUDIT_EXCEL,
  };
};

export const fetchAuditFloatingClientsExcel = ({
  document,
  lastNames,
  names,
  dateFrom,
  dateTo,
}) =>
  apiActionCreator({
    'endpoint':
      `/vehAudi/audit-floating-client-excel?document=${document || ''}&last_name=${lastNames || ''}&name=${names || ''}&date_from=${dateFrom || ''}&date_to=${dateTo || ''}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOAT_CLIENT_INVENTORY_AUDIT_EXCEL,
      ActionTypes.FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL,
      [
        ActionTypes.FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
